import { LocalizedElement } from '../i18n/Language';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SitemapRedirect = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Redirect to backend sitemap
    window.location.href = `${BACKEND_URL}/api/sitemap.xml`;
  }, []); // BACKEND_URL is constant, not needed in deps

  return (
    <LocalizedElement as="div" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'system-ui'
    }}>
      <LocalizedElement as="div" style={{ textAlign: 'center' }}>
        <LocalizedElement as="h2">Redirecting to sitemap.xml...</LocalizedElement>
        <LocalizedElement as="p">If not redirected, <LocalizedElement as="a" href={`${BACKEND_URL}/api/sitemap.xml`}>click here</LocalizedElement></LocalizedElement>
      </LocalizedElement>
    </LocalizedElement>);

};

export default SitemapRedirect;
